import {
  STATUS_ERROR,
  STATUS_LOADING,
  STATUS_NOT_REQUESTED,
  STATUS_SUCCESS,
} from 'const';
import {
  GET_TREASURY_DATA_ERROR,
  GET_TREASURY_DATA_REQUEST,
  GET_TREASURY_DATA_SUCCESS,
  GET_TREASURY_SINGLE_ACCOUNT_DATA_ERROR,
  GET_TREASURY_SINGLE_ACCOUNT_DATA_REQUEST,
  GET_TREASURY_SINGLE_ACCOUNT_DATA_SUCCESS,
  SET_TREASURY_SINGLE_ACCOUNT_STATUS_LOADING,
} from 'modules/treasuryPage/actions';

const initialState = {
  treasuryData: { datasets: {} },
  accounts: [],
  error: '',
  status: STATUS_NOT_REQUESTED,
  singleAccountStatus: STATUS_NOT_REQUESTED,
};

export const treasuryPage = (state = initialState, action) => {
  switch (action.type) {
    case GET_TREASURY_DATA_REQUEST:
      return {
        ...state,
        status: STATUS_LOADING,
      };

    case SET_TREASURY_SINGLE_ACCOUNT_STATUS_LOADING:
      return {
        ...state,
        singleAccountStatus: STATUS_LOADING,
      };

    case GET_TREASURY_DATA_SUCCESS: {
      const { accounts, ...treasuryData } = action.payload.data;
      return {
        ...state,
        treasuryData,
        accounts,
        status: STATUS_SUCCESS,
        singleAccountStatus: STATUS_SUCCESS,
      };
    }

    case GET_TREASURY_SINGLE_ACCOUNT_DATA_REQUEST:
      return {
        ...state,
        singleAccountStatus: STATUS_LOADING,
      };

    case GET_TREASURY_SINGLE_ACCOUNT_DATA_SUCCESS: {
      const treasuryAccountData = action.payload.data;
      return {
        ...state,
        treasuryData: {
          ...state.treasuryData,
          datasets: treasuryAccountData,
        },
        singleAccountStatus: STATUS_SUCCESS,
      };
    }

    case GET_TREASURY_SINGLE_ACCOUNT_DATA_ERROR:
      return {
        ...state,
        singleAccountStatus: STATUS_ERROR,
      };

    case GET_TREASURY_DATA_ERROR: {
      const { error } = action.payload;
      return {
        ...state,
        error,
        singleAccountStatus: STATUS_ERROR,
        status: STATUS_ERROR,
        treasuryData: { datasets: {} },
        accounts: [],
      };
    }

    default:
      return state;
  }
};
